import React, { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img1 from "../../../images/landing/html-css.webp";
import Img2 from "../../../images/landing/JavaScript.webp";
import Img3 from "../../../images/landing/React.webp";
import Img4 from "../../../images/landing/jQuery.webp";
import Img5 from "../../../images/landing/Angular.webp";
import Img6 from "../../../images/landing/Laravel.webp";
import Img7 from "../../../images/landing/java.webp";
import Img8 from "../../../images/landing/Ruby.webp";
import Img9 from "../../../images/landing/c-sharp.webp";
import Img10 from "../../../images/landing/codepen.webp";
import Img11 from "../../../images/landing/Windows.webp";
import Img12 from "../../../images/landing/macOS.webp";
import Img13 from "../../../images/landing/Linux.webp";
import { Link } from "gatsby";
import BannerForm from "../../components/bannerfrom";

const tabData = [
  {
    title: "01 E-commerce",
    content: [
      Img1,
      Img2,
      Img3,
      Img4,
      Img5,
      Img6,
      Img7,
      Img8,
      Img9,
      Img10,
      Img11,
      Img12,
      Img13,
    ],
  },
  {
    title: "02 Retail",
    content: [
      Img2,
      Img1,
      Img4,
      Img3,
      Img5,
      Img8,
      Img7,
      Img10,
      Img11,
      Img6,
      Img9,
      Img13,
      Img12,
    ],
  },
  {
    title: "03 Entertainment",
    content: [
      Img4,
      Img2,
      Img3,
      Img1,
      Img5,
      Img6,
      Img8,
      Img9,
      Img7,
      Img12,
      Img13,
      Img10,
      Img11,
    ],
  },
  {
    title: "04 Public Relations",
    content: [
      Img1,
      Img2,
      Img3,
      Img4,
      Img5,
      Img6,
      Img11,
      Img12,
      Img7,
      Img13,
      Img8,
      Img9,
      Img10,
    ],
  },
  {
    title: "05 Fashion",
    content: [
      Img2,
      Img1,
      Img4,
      Img3,
      Img5,
      Img11,
      Img12,
      Img8,
      Img7,
      Img13,
      Img6,
      Img10,
      Img9,
    ],
  },
  {
    title: "06 Automotive",
    content: [
      Img4,
      Img2,
      Img3,
      Img1,
      Img5,
      Img6,
      Img7,
      Img8,
      Img9,
      Img10,
      Img11,
      Img12,
      Img13,
    ],
  },
];

const Techstacklp = () => {
  const [activeTab, setActiveTab] = useState(0);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Function to handle tab click
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
      <section className="tech_stack_lpweb p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="my-auto">
              <h2>Tech-stack for Used to Industries We Development </h2>
              <p>
                As an experienced website development firm, we understand the
                significance of the latest technologies to give a competitive
                edge to clients in the market. We deploy evolving technologies.
              </p>
              <Link
                to=""
                className="lp_btn"
                aria-label="TekRevol Contact"
                onClick={handleShow}
              >
                Let’s Talk
              </Link>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={7}
              xl={7}
              xxl={7}
              className="offset-xl-1 my-auto"
            >
              <div className="tabs_lp_box">
                <div className="tabs_lp_web">
                  <ul>
                    {tabData.map((tab, index) => (
                      <li
                        key={index}
                        className={index === activeTab ? "active" : ""}
                        onClick={() => handleTabClick(index)}
                      >
                        {tab.title}
                      </li>
                    ))}{" "}
                  </ul>
                </div>
                <div className="content_lp_web">
                  <div class="img_box_lp">
                    {tabData[activeTab].content.map((image, index) => (
                      <div className="img_lp">
                        <LazyLoadImage
                          src={image}
                          effect="blur"
                          alt="Image"
                          key={index}
                          className="img-fluid"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default Techstacklp;
